import React, { useCallback, useEffect, useState } from 'react';
import { Box, Text, Button } from '@wix/design-system';
import s from './VisualTemplateStyleWidget.scss';
import { VISUAL_TEMPLATE_STYLES_WIDGET, MAX_STYLES } from '../consts';
import { VisualTemplateTag } from './VisualTemplateTag';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
export const VisualTemplateStyleWidget = _ref => {
  let {
    data: {
      widgetLabel,
      widgetSubtitle,
      visualTemplateList,
      templateStyleToLabels,
      primaryButton
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect
    },
    config
  } = _ref;
  const [selectedStyles, setSelectedStyles] = useState([]);
  const [isTagsSelected, setIsTagsSelected] = useState(false);
  const {
    areControlsDisabled
  } = useDisabledWidget(config);
  useEffect(() => {
    setIsTagsSelected(selectedStyles.length >= MAX_STYLES);
  }, [selectedStyles]);
  const widgetActionHandler = useCallback(() => {
    onWidgetAction == null || onWidgetAction(VISUAL_TEMPLATE_STYLES_WIDGET, {
      action: primaryButton.buttonName,
      value: selectedStyles
    });
    const message = `${primaryButton.respondText} ${selectedStyles.map(style => templateStyleToLabels[style]).join(', ')}`;
    send(message);
    emitSideEffect(primaryButton.sideEffectName, selectedStyles);
  }, [primaryButton, onWidgetAction, send, emitSideEffect, selectedStyles, setSelectedStyles]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "normal",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetLabel), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetSubtitle), /*#__PURE__*/React.createElement("div", {
    className: s.flexContainer
  }, visualTemplateList.map((template, index) => /*#__PURE__*/React.createElement(VisualTemplateTag, {
    title: templateStyleToLabels[template],
    template: template,
    setSelectedStyles: setSelectedStyles,
    disabled: isTagsSelected || areControlsDisabled,
    index: index
  })))), /*#__PURE__*/React.createElement(Box, {
    width: "77px",
    paddingTop: "10px"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: widgetActionHandler,
    disabled: selectedStyles.length === 0 || areControlsDisabled
  }, primaryButton.label)));
};
//# sourceMappingURL=VisualTemplateStyleWidget.js.map